<template>

  <v-dialog
    v-model="messageDialog"
    max-width="800px">
    <div class="layerPopup">
      <div class="layerTit">
        送信 Summary
      </div>
      <div class="layerContent large">
        <div class="msgDetailsDialog">
          <div class="box">
            <v-data-table
            :headers="headers_summary"
            :items="specificHistoryData"
            :search="search"
            class="UXdatatables"
            hide-actions>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center"><a :href=props.item.fileURL>{{ props.item.fileOriginalName }}</a></td>
              <td class="text-xs-center">{{ props.item.requestNum }}</td>
              <td class="text-xs-center">{{ props.item.successNum }}</td>
              <td class="text-xs-center">{{ props.item.failureNum }}</td>
              <td class="text-xs-center date" v-html="convert(props.item.requestTime)"></td>
              <td class="text-xs-center date" v-html="convert(props.item.completionTime)"></td>
              <td class="text-xs-center">{{ props.item.workingTime }}</td>
            </template>
          </v-data-table>
          </div>
          <div class="box">
            <div class="msgTit">送信メッセージの内容確認</div>
            <div class="msgBox">
              <pre>{{msgPreview}}</pre>
            </div>
          </div>
          <div class="box">
            <div class="msgTit">送信エラーの詳細</div>
            <v-data-table
            :headers="headers_error_summary"
            :items="specificErrorData"
            :search="search"
            class="UXdatatables"
            hide-actions>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.item.formatError }}</td>
              <td class="text-xs-center">{{ props.item.addressError }}</td>
              <td class="text-xs-center">{{ props.item.powerOffError }}</td>
              <td class="text-xs-center">{{ props.item.shadeError }}</td>
              <td class="text-xs-center">{{ props.item.providerError }}</td>
              <td class="text-xs-center">{{ props.item.spamError }}</td>
              <td class="text-xs-center">{{ props.item.etcError }}</td>
            </template>
          </v-data-table>
          </div>
          <v-data-table
            :headers="headers_error_summary_list"
            :items="specificErrorDataList"
            :search="search"
            class="UXdatatables"
            hide-actions>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ (errorPagination.page - 1) * errorPagination.size + (props.index + 1) }}</td>
              <td class="text-xs-center">{{ props.item.destNo }}</td>
              <td class="text-xs-center">{{ props.item.description }}</td>
            </template>
            <template v-slot:no-data>
              <div class="text-xs-center" style="padding:30px 0;">エラーの詳細がありません。</div>
            </template>
          </v-data-table>
          <pagination v-model="errorPagination.page" :length="errorPagination.totalPages" @input="errPaginationClick"></pagination>
        </div>
      </div>
      <div class="layerClose">
        <v-btn flat icon @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import helper from 'util/helpers'
import eventType from '@/components/menus/ticket/enums/eventType'
import eventBus from '@/event_bus'

export default {
  name: 'message_details_dialog.vue',
  data () {
    return {
      historyId: null,
      messageDialog: false,
      headers_summary: [
        {text: 'ファイル名', align: 'center', value: 'formatError', sortable: false, width: 28},
        {text: '要請', align: 'center', value: 'addressError', sortable: false, width: 12},
        {text: '成功', align: 'center', value: 'powerOffError', sortable: false, width: 12},
        {text: '失敗', align: 'center', value: 'shadeError', sortable: false, width: 12},
        {text: '送信開始時間', align: 'center', value: 'providerError', sortable: false, width: 12},
        {text: '送信完了時間', align: 'center', value: 'spamError', sortable: false, width: 12},
        {text: '所要時間', align: 'center', value: 'etcError', sortable: false, width: 12}],
      headers_error_summary: [
        {text: '形式エラー', align: 'center', value: 'formatÎError', sortable: false},
        {text: '欠番 | サービス停止', align: 'center', value: 'addressError', sortable: false},
        {text: '電源オフ', align: 'center', value: 'powerOffError', sortable: false},
        {text: '陰影エリア', align: 'center', value: 'shadeError', sortable: false},
        {text: 'キャリアエラー', align: 'center', value: 'providerError', sortable: false},
        {text: '迷惑エラー', align: 'center', value: 'spamError', sortable: false},
        {text: 'その他のエラー', align: 'center', value: 'etcError', sortable: false}
      ],
      headers_error_summary_list: [
        {text: 'No', align: 'center', value: 'number', sortable: false, width: 20},
        {text: '電話番号', align: 'center', value: 'phoneNumber', sortable: false, width: 30},
        {text: 'エラー内訳', align: 'center', value: 'errorText', sortable: false, width: 40}
      ],
      specificHistoryData: [{
        fileOriginalName: '',
        requestNum: 0,
        successNum: 0,
        failureNum: 0,
        requestTime: '',
        completionTime: '',
        workingTime: ''
      }],
      specificErrorData: [{
        formatError: 0,
        addressError: 0,
        powerOffError: 0,
        shadeError: 0,
        providerError: 0,
        spamError: 0,
        etcError: 0
      }],
      search: '',
      msgPreview: '',
      specificErrorDataList: [],
      errorPagination: {
        page: 1,
        size: 5,
        totalPages: 0,
        totalElements: 0
      }
    }
  },
  destroyed () {
    eventBus.$off(eventType.OPEN_MESSAGE_DETAIL_DIALOG)
  },
  mounted () {
    eventBus.$on(eventType.OPEN_MESSAGE_DETAIL_DIALOG, (id) => {
      this.messageDialog = true
      this.historyId = id
      this.openDialog(id)
    })
  },
  methods: {
    closeDialog () {
      this.messageDialog = false
    },
    openDialog (id) {
      this.errorPagination.page = 1
      this.fetchFailedLog(id, 1)

      this.axios.get(`/gateway/message/history?historyId=${id}`).then((result) => {
        const data = result.data.data

        let filename = '-'
        const sendreqTime = data.sendreqTime
        const completionTime = data.endDate
        const uploadTime = data.uploadDate

        if (data.fileUrl) {
          let fileNameArr = data.fileUrl.split('/')
          let fileOriginalName = fileNameArr[5].split('_')
          filename = fileOriginalName[0] + '.xlsx'
        } else {
          filename = '直接送信_' + uploadTime
        }
        this.msgPreview = data.msgPreview

        this.specificHistoryData = [{
          fileOriginalName: filename,
          requestNum: data.sendreqCount,
          successNum: data.successCount,
          failureNum: data.failCount,
          requestTime: sendreqTime,
          completionTime: completionTime,
          workingTime: completionTime !== '-' && sendreqTime !== '-' ? this.convertSecToHOUR((completionTime - sendreqTime)) : '-',
          fileURL: data.fileUrl
        }]
      })

      this.axios.get(`/gateway/message/history/error?id=${id}`).then((result) => {
        this.specificErrorData = [{
          formatError: result.data.data.formatErrorCount,
          addressError: result.data.data.addressErrorCount,
          powerOffError: result.data.data.powerOffErrorCount,
          shadeError: result.data.data.shadeErrorCount,
          providerError: result.data.data.providerErrorCount,
          spamError: result.data.data.spamErrorCount,
          etcError: result.data.data.etcErrorCount
        }]
      })
    },
    errPaginationClick () {
      this.fetchFailedLog(this.historyId, this.errorPagination.page)
    },
    fetchFailedLog (historyId, page) {
      this.axios.get('/gateway/message/log/fail', {
        params: {
          historyId: historyId,
          page,
          size: this.errorPagination.size
        }
      }).then((result) => {
        if (result.data.code !== 0) throw result.data.message
        this.errorPagination.totalPages = result.data.totalPages
        this.specificErrorDataList = result.data.data
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMsg => this.$alertMsg(errorMsg))
    },
    convertSecToHOUR (time) {
      if (!time) {
        return '-'
      } else if (time > 60) {
        return Math.round(time / 60) + '分 ' + Math.round(time % 60) + '秒 '
      } else if (time > 3600) {
        return Math.round(time / 3600) + '時間 ' + Math.round((time % 3600) / 60) + '分 ' + Math.round((time % 3600) % 60) + '秒'
      } else {
        return time + '秒'
      }
    },
    convert (dateTime) {
      return dateTime !== undefined ? `${helper.convertDateYyyyMmDd(dateTime)} <span>${helper.printTimeStampFromDateTimeWithoutAP(dateTime)}</span>` : '-'
    }
  }
}
</script>

<style lang="scss">
.msgDetailsDialog {
  .box {
    padding-bottom: 20px;
    .msgTit {
      padding-bottom:5px;
      font-size: 14px;
      font-weight: bold;
      color:$gray-8;
    }
    .msgBox {
      padding:10px;
      height:100px;
      overflow-y: auto;
      border:1px solid $gray-3;
      color:$gray-8;
      border-radius: 3px;
      pre {
        font-size:12px;
      }
    }
  }
  .UXdatatables {
    table.v-datatable {
      thead {
        tr {
          th {
            color:$gray-8;
            font-size: 14px;
          }
        }
      }
      tbody {
        tr {
          td {
            font-size: 14px;
            color:$gray-7;
            a {
              color:$gray-7;
            }
            &.date {
              color:$gray-8;
              line-height:18px;
              span {
                display: block;
                color:$gray-6;
              }
            }
          }
        }
      }
    }
  }
  .UXpagination {
    padding: 15px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/message_details_dialog.vue